import { match as Match, useHistory, useLocation, useRouteMatch } from 'react-router-dom'
import { History, LocationState } from 'history'
import { Location } from 'history'

type RouterState<TParams extends Record<string, string | undefined>> = {
  history: History<LocationState>
  location: Location<LocationState>
  match: Match<TParams>
}

const useRouter = <TParams extends Record<string, string | undefined> = Record<string, string | undefined>>(): RouterState<TParams> => {
  const history = useHistory<LocationState>()
  const location = useLocation<LocationState>()
  const match = useRouteMatch<TParams>() as Match<TParams>

  return {
    history,
    location,
    match,
  }
}

export default useRouter
